var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-html",domProps:{"innerHTML":_vm._s(
    _vm.field && _vm.field.value && _vm.field.value.text ? _vm.field.value.text : _vm.field.value
  )}})}
var staticRenderFns = []

export { render, staticRenderFns }